/**
 * @file test-plan.tsx
 * @description Компонент страницы каталога тест-планов для управления сущностями тест-планов в системе 
 * управления задачами. Предоставляет функциональность создания, редактирования и просмотра тест-планов 
 * с поддержкой иерархических групп. Включает отслеживание автора для отчётности по тест-планам и 
 * фильтрацию по дате для эффективной организации тест-планов. Использует одновкладочный интерфейс, 
 * ориентированный на обзор и базовое управление тест-планами.
 * @author AI Assistant
 * @created 2025-09-04
 * @updated 2025-09-04
 * @dependencies ['@utils/table-view', '@forms/test-plan', '@features/filter/types', '@forms/test-plan/tabs']
 * @related-files ['@forms/test-plan/index.tsx', '@forms/test-plan/tabs/Main.tsx']
 */

import { getDefaultCell } from '@utils/table-view';
import { TestPlanForm } from '@forms/test-plan';
import { tabObject, TBaseObjectDto } from '@src/types';
import { filterComponent } from '@features/filter/types';
import { Main } from '@forms/test-plan/tabs';

export const title = 'Тест планы';
export const searchModalTitle = 'Выбор тест плана';
export const type = 'TestPlan';
export const parentType = 'TestPlanGroup';
export const path = 'test-plan';
export const form = TestPlanForm;
export const isCanAddGroups = true;
export const tabs: tabObject[] = [{ label: 'Обзор', component: Main }];

export const columns = [
    {
        id: '$item',
        header: [{ text: 'Наименование' }],
        render: (cellValue: any) => getDefaultCell(cellValue)
    },
    {
        id: 'author',
        header: [{ text: 'Автор' }],
        render: (cellValue: any) => getDefaultCell(cellValue)
    }
];

export const getFilterControls = (data: TBaseObjectDto = {}): filterComponent[] => [
    {
        filterType: 'dateRange',
        filterProps: {
            label: 'Дата'
        },
        value: data.date,
        name: 'date',
        tab: 'filters'
    }
];
